<div class="chip" [ngStyle]="{ 'background-color': backgroundColor,'color': color,'border-color': borderColor, 'opacity':opacity }">{{text}}</div>